import { MutableRefObject } from 'react';
import { noop } from 'lodash';

import { createContext } from 'use-context-selector';

import { FormControlIndex } from './FormTabIndexProvider.types';

interface FormTabIndexProviderContextProps {
  indexes: FormControlIndex;
  removeIndex: (key: number) => void;
  focusNext: (v: number) => void;
  setIndex: (key: number, v: MutableRefObject<HTMLIonInputElement>) => void;
}

export const FormTabIndexProviderContext =
  createContext<FormTabIndexProviderContextProps>({
    indexes: {},
    setIndex: noop,
    focusNext: noop,
    removeIndex: noop,
  });
